import React, { useState, useEffect, useRef } from "react";
import { flushSync } from "react-dom";
import Header from '../../../Components/Header/header';
import Back from '../../../Components/back/back';
import Refresh from '../../../Components/refresh/refresh';
import Writing from '../../../Components/typewriter/typewriter';
import config from '../../../Context/Config';
import '../../../css/loader.css';
import { useLocation, useParams, useNavigate } from "react-router-dom";
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import logo from '../../../Components/Assets/logo.svg'
import andrews from '../../../Components/Assets/andrews.jpeg'
import Rocket from '../../../Components/rocket/rocket';
import { showSuccess, showError, showCustomAlert, showSessionExpired } from '../../../Utils/swal';
import { toJpeg } from 'html-to-image';
import { jsPDF } from 'jspdf';
import { refreshToken } from '../../../Context/RefreshToken';
import NextBtnLoader from "../../../Components/loader/loader";
import FormInput from "../../../Components/formInput/formInput";
import TimePickerInput from "../../../Components/timePicker/timePicker";
import MedTimePicker from "../../../Components/timePicker/medTimePicker";
import DatePickerInput from "../../../Components/datePicker/datePicker";
import DOBPickerInput from "../../../Components/dobPicker/dobPicker";
import TextInput from "../../../Components/textInput/textInput";
import TextArea from "../../../Components/textInput/textarea";
import TextAreaInput from "../../../Components/textInput/textareaInput";
import SelectInput from "../../../Components/selectInput/select";
import RadioGroup from "../../../Components/radio/radio";
import Paragraph from "../../../Components/paragraph/paragrah";
import SignatureField from "../../../Components/signature/signature";
import BackgruseRedirectIfNotLoggedIn from '../../../Components/redirect/redirect';
import OneMedical from '../../../Components/surgicalTemplate/oneMedical';
import Baldwin from '../../../Components/surgicalTemplate/baldwin';
import Emerald from '../../../Components/surgicalTemplate/emerald';
import Andrews from "../../../Components/surgicalTemplate/andrews";
import RSIConsent from "../../../Components/surgicalComponents/rsiConsent"
import Logo from '../../../Components/InfoDisplay/logo';
import Head from '../../../Components/InfoDisplay/header';
import SurgeryInfoDisplay from '../../../Components/InfoDisplay/surgicalinfo';
import { uploadWithXHR } from "../../../Utils/upload";
import { formattingDate, displayDate, getCentralAmericaDate, getCentralAmericaTime } from "../../../Utils/formatDate";
import { checkTokenAndNavigate } from "../../../Utils/checkNavigate";
import { loadImageSafely } from "../../../Utils/loadImages";
import { compressImageForIOS } from "../../../Utils/compress";
import { rsisurgeonsOptions, anesthesiaOptions, rsiFullNamesurgeonsOptions, eyesOptions } from '../../../Utils/Options';
import { waitForImages } from "../../../Utils/domUtils";
import { stitchedImages } from "../../../Utils/stitchImages";
import { useZoom } from "../../../Context/Zoom";
import { useAutoTokenRefresh } from "../../../Context/refresh";
import LeftCheckBox from "../../../Components/selectInput/leftCheckBox";


const SurgeryPageForm = () => {
    const { zoom, setZoom } = useZoom();
    const [nextLoader, setNextLoader] = useState(false);
    const location = useLocation();
    const [pageTitle, setPageTitle] = useState('');
    const [currentPage, setCurrentPage] = useState(0);
    const { chart, date , apptId } = useParams();
    const currentDate = new Date();

    // Enhanced image loading with better error handling
    const formatDate = (unformattedDate) => {
        try {
            const formattedDate = formattingDate(unformattedDate);
            return formattedDate
        } catch (err) {
            console.error('Error formatting date:', err.message);
        }
    };

    const formattedDate = formatDate(currentDate); // Formats current date


    const [totalPages, setTotalPages] = useState(9)
    const pageRefs = useRef(
        Array(totalPages)
            .fill(null)
            .map(() => React.createRef())
    );
    const [capturedPages, setCapturedPages] = useState(Array(totalPages).fill(null)); // Create an array of refs
    const { openedViaButton } = location.state || {};
    BackgruseRedirectIfNotLoggedIn(openedViaButton, 50, "/context-not-found");

    const [verifyDob, setVerifyDob] = useState("");
    const [localpatientid, setlocalpatientid] = useState("");
    const [isLoading3, setIsLoading3] = useState(false);
    const [isLoading4, setIsLoading4] = useState(false);
    const [invalidFields, setInvalidFields] = useState([]);
    const [surgeryUpload, setSurgeryUpload] = useState(false);
    const taskRunRef = useRef(false);
    const [SurgeryFormData, setSurgeryFormData] = useState({
        first_name: "",
        last_name: "",
        ssn: "",
        gender: "",
        dob: "",
        cellphone: "",
        surgeon: "",
        surgeon_fullname: "",
        office_contact: "",
        office_phone: "",
        length_of_surgery: "",
        cpt_codes: "",
        icd10_codes: "",
        procedure: "",
        diagnosis: "",
        anesthesia: "mac",
        type: "",
        pat_notes: "",
        special_equipment: "",
        vendor_rep: "",
        c_arm_required: "",
        special_needs: "",
        allergies: "",
        catheter:"",
        wc_case: "",
        authorization_required: "",
        authorization_number: "",
        contact_person: "",
        contact_phone: "",
        contact_provider_organization: "",
        patient_signature: "",
        surrogate_signature: "",
        doctor_signature: "",
        rn_signature: "",
        witness_signature: "",
        requested_date_of_surgery: "",
        requested_time_of_surgery: "",
        interpreter: "",
        consent_to_read: "",
        operationTime: "",
        operationDate: "",
        signedTime: "",
        signedDate: "",
        patientSignedTime: "",
        patientSignedDate: "",
        surrogateSignedTime: "",
        surrogateSignedDate: "",
        rnSignedTime: "",
        rnSignedDate: "",
        witnessSignedTime: "",
        witnessSignedDate: "",
        block_anesthesiologist: "",
        block_surgeon: "",
        preop_clearance: "",
        additionalorders: "",
        eyes: "",
        unable_to_sign: {
            reason: "",
            printedName: "",
            relationship: "",
            witness: "",
        },
        emerald_medication_times: {
            "Cyclopentolate 1% (Cyclogyl)": ["", "", ""],
            "Atropine 1%": ["", "", ""],
            "Phenylephrine 2.5%": ["", "", ""]
        },
        andrew_admission: {
            "Preoperative medication per anesthesia": false,
            "NPO": false,
            "Void on call to OR": false
        },
        emerald_labtests: {
            "BMP": false,
            "CBC": false,
            "Creatinine": false,
            "CMP": false,
            "CA27.29": false,
            "CXR": false,
            "EKG": false,
            "PT/PTT & INR": false,
            "QUANT HCG": false,
            "TSH": false,
            "COVID TEST": false,
            "UA": false,
        },
        emerald_medications: {
            "Afrin 2 Sprays each nostril": false,
            "Ancef 1 GM IVP": false,
            "Ancef 2 GM IVP": false,
            "Ancef 25 mg/kg IVPB": false,
            "Vancomycin 500 mg IVPB": false,
            "Vancomycin 1 gm IVPB": false,
            "Clindamycin 300 mg IVPB": false,
            "Clindamycin 600 mg IVPB": false,
            "Clindamycin 900 mg IVPB": false,
            "Levaquin 500 mg IVPB": false,
            "Levaquin 750 mg IVPB": false,
            "Mefoxin 1GM IVPB": false,
            "Mefoxin 2 GM IVPB": false,
            "Decadron 4 mg IV": false,
            "Decadron 10 mg IV": false,
            "Decadron 0.25 mg/kg IV": false,
            "Heparin 5,000 Units SubQ": false,
            "Benadryl 25mg IV": false,
            "Zantac 50mg IVPB": false,
            "Zofran 4mg IV": false,
            "Lidocaine 4% 3mL+ Albuterol 2.5mg 3mL Nebulizer": false,
            "Xanax 1mg PO": false,
        },
        one_medical_medications: {
            "Cefazolin (Ancef) 1gm if pt < 80kg or 2gm if pt ≥ 80kg": false,
            "Clindamycin 600 mg IVPB": false,
            "Gentamycin 80mg": false,
            "Levofloxacin (Levaquin) 500mg": false,
            "Vancomycin (circle one) 0.5gm 1gm": false,
            "Other": false
        },
        other_medication: "",
        risk_assesment: "",
        emerald_preop_orders: {
            "Admit per Protocol Includes": false,
            "NPO": false,
            "Admit": false,
            "IV access": false,
            "Accu-Check": false,
            "Apply Sequential": false,
            "Shave Operative Site": false,
            "Hibiclens—Betadine Prep Operative Site": false,
        },
        emerald_admission: {
            "Preoperative medication per anesthesia": false,
            "NPO": false,
            "Void on call to OR": false
        },
        andrew_medication_times: {
            "Cyclopentolate 1% (Cyclogyl)": ["", "", ""],
            "Atropine 1%": ["", "", ""],
            "Phenylephrine 2.5%": ["", "", ""]
        },
        preop_surgical_site: {
            "Clip Hair": ""
        },
        witness_name: '',
        difficult_intubation: "",
        malignant_hyperthermia: "",
        blood_thinners: "",
        blood_thinners_list: "",
        height: "",
        weight: "",
        pacemaker: "",
        pacemaker_dependent: "",
        defibrillator: "",
        defibrillator_fired: "",
        chest_pain: "",
        weight_loss_drugs_taker: "",
        weight_loss_drugs: "",
        diuretic_taker: "",
        claustrophobic: "",
        hemodialysis_user: "",
        oxygenTaker: "",
        pcp: "",
        procedure_description: "",
        rep_name: "",
        rep_phone: "",
        alternatives: "",
        labs_anesthesia: "",
        vital_signs: "",
        noted_date: "",
        noted_signature: "",
        noted_time: "",
        nka: "",
        npo: "",
        other_diet: "",
        iv_fluids: {
            "Lactated Ringers IV solution 1000ml at KVO in Pre-op Hair": ""
        },
        labs_diagnostic: {
            "Urine Pregnancy Test, if indicated": ""
        },
        meds_in_op_room: {
            "5% Betadine flush to operative eye upon just prior to incision and at conclusion of case.": "",
            "0.3mL of Img/0.1mL Vancomycin in a 1mL syringe.": "",
            "Indocyanine Green and Diutant": ""
        },
        dilation_eyes: {
            "OD (Right Eye)": "",
            "OS (Left Eye)": "",
            "OU (Both Eyes)": "",
        },
        dilation_medications: {
            "Proparacaine 0.5% ophthalmic solution – one drop to operative eye prior to dilating drops and 5% Betadine": "",
            "Tropicamide 1% ophthalmic solution (Mydriacyl) – one drop every 5 minutes for 3 doses": "",
            "Phenylephrine 10% ophthalmic solution (Neo-Synephrine) – one drop every 5 minutes for 3 doses": "",
            "Cyclopentolate 1% ophthalmic solution (Cyclogyl) – one drop every 5 minutes for 3 doses": "",
            "Flurbiprofen 0.03% ophthalmic suspension – one drop every 5 minutes for 3 doses": ""
        },
        date_time: "",
        nkda: false,
        consent_procedures: {
            "right_eye": {
                "Vitrectomy": "",
                "Laser": "",
                "Epiretinal Membrane Peel": "",
                "Internal Limiting Membrane Peel": "",
                "Air / Fluid / Gas Exchange": "",
                "Silicone Oil Insertion": "",
                "Silicone Oil Removal": "",
                "Lensectomy": "",
                "Scleral Buckle": "",
                "Any other indicated procedure": ""
            },
            "left_eye": {
                "Vitrectomy": "",
                "Laser": "",
                "Epiretinal Membrane Peel": "",
                "Internal Limiting Membrane Peel": "",
                "Air / Fluid / Gas Exchange": "",
                "Silicone Oil Insertion": "",
                "Silicone Oil Removal": "",
                "Lensectomy": "",
                "Scleral Buckle": "",
                "Any other indicated procedure": ""
            }
        }

    });
    const [template, setTemplate] = useState('')
    const [signatures, setSignatures] = useState({
        witness_signature: '',
        patient_signature: '',
        doctor_signature: '',
        rn_signature: '',
        surrogate_signature: '',
        noted_signature: ''
    });
    const [isNext, setIsNext] = useState(false)
    const [isEditing, setIsEditing] = useState({});
    const canvasRefs = {
        witness_signature: useRef(null),
        patient_signature: useRef(null),
        doctor_signature: useRef(null),
        rn_signature: useRef(null),
        surrogate_signature: useRef(null),
        noted_signature: useRef(null)
    };

    let docSignature = {
        "Dr. Allison": "data:image/jpeg;base64,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",
        "Dr. Baranano": "data:image/jpeg;base64,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",
        "Dr. Shuler": "data:image/jpeg;base64,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",
        "Dr. Ozkok": "data:image/jpeg;base64,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",
        "Dr. Tarantola": "data:image/jpeg;base64,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",
        "Dr. Gupta": "data:image/jpeg;base64,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",
        "Dr. Myers": "data:image/jpeg;base64,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"
    };


    const surgeonOptionsMap = {
        "rsi": rsisurgeonsOptions
    };

    const surgeonFullnameOptionsMap = Object.fromEntries(
        rsiFullNamesurgeonsOptions.map(option => [option.value, option.label])
    );

    const navigate = useNavigate();
    useAutoTokenRefresh({ navigate, intervalMs: 5 * 60 * 1000 });
    const buttonClasses = "px-6 py-3 bg-blue-600 text-white rounded-lg shadow-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-opacity-50 transition-all";

    const tryRefresh = async (autoReloadBool) => {
        try {
            setIsLoading3(true)
            await refreshToken({
                navigate,
                onSuccess: (token) => console.log("Refreshed:", token),
                onError: (err) => console.error("Failed to refresh", err),
                autoReload: autoReloadBool
            });
        }
        finally {
            setIsLoading3(false)
        }
    };

    const handleMedicationTimeChange = (formKey, med, index, value) => {
        setSurgeryFormData((prev) => ({
            ...prev,
            [formKey]: {
                ...prev[formKey],
                [med]: prev[formKey][med].map((val, i) =>
                    i === index ? value : val
                ),
            },
        }));
    };

    const handleProcedureChange = (eye, procedure, value) => {
        setSurgeryFormData((prev) => ({
            ...prev,
            consent_procedures: {
                ...prev.consent_procedures,
                [eye]: {
                    ...prev.consent_procedures[eye],
                    [procedure]: value,
                },
            },
        }));
    };

    const renderNextButton = () => (
        <button type="button" onClick={handleNext} className={buttonClasses} id="next">
            <i className="fas fa-arrow-right mr-2"></i> <span>Next</span>
        </button>
    );

    const renderSurgeryUploadButton = () => (
        <button onClick={handleSurgerySubmit} type="button" className={`flex items-center ${buttonClasses}`}>
            <i className="fas fa-file-signature mr-2"></i> Upload Surgery Form
        </button>
    );

    // Function to handle API call
    const runTask = async () => {
        setIsLoading4(true);
        if (taskRunRef.current) return; // Prevent running if task has already been executed
        taskRunRef.current = true;
        try {
            const response = await fetch(`${config.API_BASE_URL}/surgical/get_surgery_data`, {
                method: 'POST',
                headers: {
                    "action_id": config.ACTIONID['view'], // Assuming this is set correctly
                    "Content-Type": "application/json",
                    Authorization: `${localStorage.getItem("digital-form-idtoken")}`,
                    "practice": localStorage.getItem("digital-form-dept-practice")

                },
                body: JSON.stringify({
                    apptId: apptId
                }),
            });

            if (response.ok) {
                // setIsLoading4(false);
                const data = await response.json();
                if (data) {
                    const patData = data
                    setVerifyDob(patData["formatted_dob"])
                    flushSync(() => setlocalpatientid(patData.localpatientid))

                    if (patData['template']) {
                        setTemplate(patData['template'])
                        setTotalPages(patData['total_pages'])
                    }
                    setSurgeryFormData((prevData) => ({
                        ...prevData, // Preserve existing dynamically added fields
                        first_name: patData["first_name"] || "",
                        last_name: patData["last_name"] || "",
                        surrogate_signature: patData["surrogate_signature"] || "",
                        patient_signature: patData["patient_signature"] || "",
                        doctor_signature: patData["doctor_signature"] || "",
                        rn_signature: patData["rn_signature"] || "",
                        witness_name: patData["witness_name"] || "",
                        witness_signature: patData["witness_signature"] || "",
                        noted_signature: patData["noted_signature"] || "",
                        ssn: patData["ssn"] || "", // If ssn is null, set it to an empty string
                        gender: ["male", "m"].includes(patData["gender"]?.toLowerCase()) ? "M" :
                            ["female", "f"].includes(patData["gender"]?.toLowerCase()) ? "F" : "",
                        dob: patData["formatted_dob"] || "", // Format the date if available
                        cellphone: patData["cellphone"] || "",
                        rep_name: patData["rep_name"] || "",
                        rep_phone: patData["rep_phone"] || "",
                        eyes: patData["eyes"] || "",
                        surgeon: patData["surgeon"] || "",
                        surgeon_fullname: patData["surgeon_fullname"] || "",
                        office_contact: patData["office_contact"] || "",
                        office_phone: patData["office_phone"] || "",
                        length_of_surgery: patData["length_of_surgery"] || "",
                        cpt_codes: patData["cpt_codes"] || "",// If cpt_codes is null, set it to an empty string
                        icd10_codes: patData["icd10_codes"] || "",
                        procedure: patData["procedure"] || "",
                        procedure_description: patData["procedure_description"] || "",
                        diagnosis: patData["diagnosis"] || "",
                        anesthesia: patData["anesthesia"]?.toLowerCase() || "mac",
                        type: patData["type"]?.toLowerCase() || "",
                        pat_notes: patData["pat_notes"]?.toLowerCase() || "",
                        special_equipment: patData["special_equipment"] || "",
                        vendor_rep: patData["vendor_rep"] === true ? true : patData["vendor_rep"] === false ? false : "",
                        c_arm_required: patData["c_arm_required"] || "",
                        special_needs: patData["special_needs"] || "",
                        allergies: patData["allergies"] || "",
                        catheter: patData["catheter"] === true ? true : patData["catheter"] === false ? false : "",
                        nkda: patData["nkda"] === true ? true : patData["nkda"] === false ? false : "",
                        wc_case: patData["wc_case"] === true ? true : patData["wc_case"] === false ? false : "",
                        pcp: patData["pcp"] || "",
                        authorization_required: patData["authorization_required"] === true ? true : patData["authorization_required"] === false ? false : "",
                        authorization_number: patData["authorization_number"] || "",
                        contact_person: patData["contact_person"] || "",
                        contact_phone: patData["contact_phone"] || "",
                        contact_provider_organization: patData["contact_provider_organization"] || "",
                        requested_date_of_surgery: patData["requested_date_of_surgery"] || "",
                        requested_time_of_surgery: patData["requested_time_of_surgery"] || "",
                        nka: patData["nka"] === true ? true : patData["nka"] === false ? false : "",
                        npo: patData["npo"] === true ? true : patData["npo"] === false ? false : "",
                        generically_acceptable: patData["generically_acceptable"] === true ? true : patData["generically_acceptable"] === false ? false : "",
                        interpreter: patData["interpreter"] === true ? true : patData["interpreter"] === false ? false : "",
                        consent_to_read: patData["consent_to_read"] || "",
                        block_anesthesiologist: patData["block_anesthesiologist"] || "",
                        block_surgeon: patData["block_surgeon"] || "",
                        preop_clearance: patData["preop_clearance"] === true ? true : patData["preop_clearance"] === false ? false : "",
                        emerald_medication_times: patData["emerald_medication_times"] || { ...prevData.emerald_medication_times },
                        andrew_admission: patData["andrew_admission"] || { ...prevData.andrew_admission },
                        unable_to_sign: patData["unable_to_sign"] || { ...prevData.unable_to_sign },
                        emerald_labtests: patData["emerald_labtests"] || { ...prevData.emerald_labtests },
                        emerald_medications: patData["emerald_medications"] || { ...prevData.emerald_medications },
                        emerald_preop_orders: patData["emerald_preop_orders"] || { ...prevData.emerald_preop_orders },
                        emerald_admission: patData["emerald_admission"] || { ...prevData.emerald_admission },
                        andrew_medication_times: patData["andrew_medication_times"] || { ...prevData.andrew_medication_times },
                        additionalorders: patData["additionalorders"] || "",
                        difficult_intubation: patData["difficult_intubation"] || "",
                        malignant_hyperthermia: patData["malignant_hyperthermia"] || "",
                        blood_thinners: patData["blood_thinners"] || "",
                        blood_thinners_list: patData["blood_thinners_list"] || "",
                        height: patData["height"] || "",
                        weight: patData["weight"] || "",
                        pacemaker: patData["pacemaker"] || "",
                        pacemaker_dependent: patData["pacemaker_dependent"] || "",
                        defibrillator: patData["defibrillator"] || "",
                        defibrillator_fired: patData["defibrillator_fired"] || "",
                        chest_pain: patData["chest_pain"] || "",
                        weight_loss_drugs_taker: patData["weight_loss_drugs_taker"] || "",
                        weight_loss_drugs: patData["weight_loss_drugs"] || "",
                        diuretic_taker: patData["diuretic_taker"] || "",
                        claustrophobic: patData["claustrophobic"] || "",
                        hemodialysis_user: patData["hemodialysis_user"] || "",
                        oxygenTaker: patData["oxygentaker"] || "",
                        signedDate: patData["signeddate"] || "",
                        signedTime: patData["signedtime"] || "",
                        witnessSignedDate: patData["witnesssigneddate"] || "",
                        witnessSignedTime: patData["witnesssignedtime"] || "",
                        surrogateSignedTime: patData["surrogatesignedtime"] || "",
                        surrogateSignedDate: patData["surrogatesigneddate"] || "",
                        rnSignedTime: patData["rnsignedtime"] || "",
                        rnSignedDate: patData["rnsigneddate"] || "",
                        patientSignedDate: patData["patientsigneddate"] || "",
                        patientSignedTime: patData["patientsignedtime"] || "",
                        operationDate: patData["operationdate"] || "",
                        operationTime: patData["operationtime"] || "",
                        noted_time: patData["noted_time"] || "",
                        noted_date: patData["noted_date"] || "",
                        alternatives: patData['alternatives'] || "",
                        vital_signs: patData['vital_signs'] || "",
                        risk_assesment: patData['risk_assesment'] || "",
                        other_medication: patData['other_medication'] || "",
                        other_diet: patData['other_diet'] || "",
                        labs_anesthesia: patData['labs_anesthesia'] || "",
                        other_preop_surgical_site: patData['other_preop_surgical_site'],
                        preop_surgical_site: patData["preop_surgical_site"] || { ...prevData.preop_surgical_site },
                        one_medical_medications: patData["one_medical_medications"] || { ...prevData.one_medical_medications },
                        iv_fluids: patData["iv_fluids"] || { ...prevData.iv_fluids },
                        labs_diagnostic: patData["labs_diagnostic"] || { ...prevData.labs_diagnostic },
                        meds_in_op_room: patData["meds_in_op_room"] || { ...prevData.meds_in_op_room },
                        dilation_eyes: patData["dilation_eyes"] || { ...prevData.dilation_eyes },
                        dilation_medications: patData["dilation_medications"] || { ...prevData.dilation_medications },
                        consent_procedures: patData["consent_procedures"] || { ...prevData.consent_procedures },
                        date_time: patData['date_time'] || ""
                    }));

                    setSignatures((prev) => ({
                        ...prev,
                        patient_signature: patData.patient_signature ?? "",
                    }));
                    setSignatures((prev) => ({
                        ...prev,
                        surrogate_signature: patData.surrogate_signature ?? "",
                    }));

                    setSignatures((prev) => ({
                        ...prev,
                        witness_signature: patData.witness_signature ?? "",
                    }));
                    setSignatures((prev) => ({
                        ...prev,
                        rn_signature: patData.rn_signature ?? "",
                    }));
                    setSignatures((prev) => ({
                        ...prev,
                        noted_signature: patData.noted_signature ?? "",
                    }));
                }
                else {
                    showCustomAlert('warning', 'Error', "No data found!", 'Retry', () => {
                        window.location.reload();
                    });
                }
            } else {
                if (response.status === 401) {
                    showSessionExpired(() => tryRefresh(true));
                } else if (response.status === 403) {
                    showError("Forbidden", "You don't have permission to view the surgical data.");
                } else if (response.status === 500) {
                    showError("Server Error", "There was a server error while fetching the surgical data. Please try again later.");
                } else {
                    showError("Error", "There was an issue fetching the surgical data. Please try again later.");
                }
            }
        } catch (error) {
            console.error('Error:', error);
        }
        finally {
            setIsLoading4(false);
        }
    }


    const update_database = async (key) => {
        const departmentData = JSON.parse(localStorage.getItem("selectedLocation"));

        const response = await fetch(`${config.API_BASE_URL}/update_database`, {
            method: "POST",
            headers: {
                "action_id": config.ACTIONID['edit'], // Assuming this is set correctly
                "Content-Type": "application/json",
                Authorization: `${localStorage.getItem("digital-form-idtoken")}`,
                "practice": localStorage.getItem("digital-form-dept-practice")
            },
            body: JSON.stringify({
                entID: chart,
                apptId: apptId,
                key: key,
                form_type: "surgery",
                chart: localpatientid,
                form: SurgeryFormData,
                dept_id: departmentData.id,
                practice: `${localStorage.getItem("digital-form-dept-practice")}`,
            }),
        });
        if (response.ok) {
            setSurgeryUpload(false);
        }
        else {
            setSurgeryUpload(false);
            if (response.status === 401) {
                showSessionExpired(async () => {
                    await tryRefresh(false);
                    update_database(key);
                });
            } else if (response.status === 403) {
                showError("Forbidden", "You don't have permission to update data.");
            } else if (response.status === 500) {
                showError("Server Error", "There was a server error while updating data. Please try again later.");
            } else {
                showError("Error", "There was an issue while updating data. Please try again later.");
            }
        }
    }


    async function capturePageAsImage() {
        try {
            const node = pageRefs.current[currentPage]?.current;
            if (!node) throw new Error("Page reference not found");

            const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

            // Wait for all images
            await waitForImages(node);

            // Save original styles
            const originalStyle = {
                width: node.style.width,
                transform: node.style.transform,
                webkitTransform: node.style.webkitTransform,
            };

            // Force full content width
            const fullWidth = node.scrollWidth;
            const fullHeight = node.scrollHeight;

            node.style.width = `${fullWidth}px`;

            // iOS-specific rendering hack
            if (isIOS) {
                node.style.transform = 'translateZ(0)';
                node.style.webkitTransform = 'translateZ(0)';
                await new Promise(res => setTimeout(res, 500));
                void node.offsetHeight; // force reflow
                await new Promise(res => setTimeout(res, 200));
            } else {
                await new Promise(res => setTimeout(res, 100));
            }

            // Capture the node
            const image = await toJpeg(node, {
                cacheBust: true,
                quality: 0.95,
                backgroundColor: "#FFFFFF",
                margin: "1px",
                width: fullWidth,
                height: fullHeight,
                ...(isIOS && { pixelRatio: window.devicePixelRatio || 1 }),
            });

            // Restore original styles
            node.style.width = originalStyle.width;
            node.style.transform = originalStyle.transform;
            node.style.webkitTransform = originalStyle.webkitTransform;

            // Save captured page
            setCapturedPages(prev => {
                const updated = [...prev];
                updated[currentPage] = image;
                return updated;
            });

            return image;
        } catch (error) {
            console.error("Error capturing page:", error);
            throw error;
        }
    }


    const stitchImages = async (image1, image2) => {
        try {
            const stitchedBase64 = await stitchedImages([
                image1,
                image2,
            ]);
            return stitchedBase64
        } catch (err) {
            console.error("Error stitching images:", err);
        }
    };

    const handleLastPage = async () => {
        const image = await capturePageAsImage();
        return image;
    };

    const handleUpload = async (url, blob) => {
        try {
            const response = await uploadWithXHR(url, blob);
            console.log('Upload successful:', response);
        } catch (err) {
            console.error('Upload error:', err.message);
        }
    };


    // Enhanced image loading with better error handling
    // Process images with enhanced error handling
    const processImagesForSurgery = async (capturedPages, capturedPage, template) => {
        const comboRules = {
            'Andrews Institute': { skip: [1, 4, 8], combos: [[0, 1], [3, 4], [7, 8]] },
            'Emerald Coast Surgery Center': { skip: [1, 3], combos: [[0, 1], [2, 3]] },
            'Summit Surgery Center': { skip: [], combos: [] },
            'Baldwin Co Surgery Center':{ skip: [], combos: [] },
        };

        const { skip, combos } = comboRules[template] || { skip: [], combos: [] };
        const processedImages = [];


        for (let i = 0; i < capturedPages.length; i++) {
            if (skip.includes(i)) {
                continue;
            }

            try {
                const combo = combos.find(([first]) => first === i);
                let imageToProcess;

                if (combo && (capturedPages[combo[1]] || (combo[0] === 7 && template === 'Andrews Institute' && capturedPage))) {

                    // Load first image
                    const img1 = await loadImageSafely(capturedPages[combo[0]]);

                    // Determine second image source
                    const img2Source = (combo[0] === 7 && template === 'Andrews Institute')
                        ? capturedPage
                        : capturedPages[combo[1]];

                    // Load second image
                    const img2 = await loadImageSafely(img2Source);

                    // Stitch images together
                    imageToProcess = await stitchImages(img1.src, img2.src);
                } else {
                    // Process single image
                    const sourceImage =
                        (template === "Emerald Coast Surgery Center" && i === 4) ||
                            (template === "Summit Surgery Center" && (i === 1 || i === 2) ) || (template === "Baldwin Co Surgery Center" && (i === 1 || i === 2))
                            ? capturedPage
                            : capturedPages[i];


                    if (!sourceImage) {
                        throw new Error(`No source image available for index ${i}`);
                    }

                    imageToProcess = sourceImage;
                }

                // Compress the image for iOS compatibility
                const compressedImage = await compressImageForIOS(imageToProcess, 0.8, 1200);
                processedImages.push(compressedImage);


            } catch (error) {
                console.error(`Failed to process image at index ${i}:`, error);
                throw new Error(`Failed to process image at index ${i}: ${error.message}`);
            }
        }

        return processedImages;
    };

    // Enhanced PDF generation with better error handling
    const generateSurgicalPDF = async (images, localpatientid, apptId) => {

        const pdf = new jsPDF({
            orientation: "portrait",
            unit: "pt",
            format: "a4",
        });

        const pageWidth = 595.28;
        const pageHeight = 841.89;

        for (let i = 0; i < images.length; i++) {
            try {
                const img = await loadImageSafely(images[i]);

                // Calculate dimensions to fit page while maintaining aspect ratio
                const imgRatio = img.width / img.height;
                const pageRatio = pageWidth / pageHeight;

                let drawWidth, drawHeight;
                if (imgRatio > pageRatio) {
                    drawWidth = pageWidth;
                    drawHeight = pageWidth / imgRatio;
                } else {
                    drawHeight = pageHeight;
                    drawWidth = pageHeight * imgRatio;
                }

                const x = (pageWidth - drawWidth) / 2;
                const y = (pageHeight - drawHeight) / 2;

                if (i > 0) pdf.addPage();
                pdf.addImage(img, "JPEG", x, y, drawWidth, drawHeight);


            } catch (error) {
                console.error(`Failed to add image ${i} to PDF:`, error);
                throw new Error(`Failed to add image ${i + 1} to PDF: ${error.message}`);
            }
        }

        const pdfBlob = pdf.output("blob");
        const filename = `${localpatientid}--${apptId}-surgical-form.pdf`;
        // pdf.save(filename);

        return { pdfBlob, filename };
    };


    // Enhanced upload with multiple fallback methods
    const uploadSurgicalPDF = async (pdfBlob, localpatientid, apptId, config) => {
        try {
            const response = await fetch(`${config.API_BASE_URL}/get_presigned_url`, {
                method: "POST",
                headers: {
                    "action_id": config.ACTIONID['view'],
                    "Content-Type": "application/json",
                    Authorization: `${localStorage.getItem("digital-form-idtoken")}`,
                    "practice": localStorage.getItem("digital-form-dept-practice")
                },
                body: JSON.stringify({
                    object_name: `${localpatientid}-${apptId}-surgical-form.pdf`,
                    chart: localpatientid,
                    form_type: "surgery",
                    practice: `${localStorage.getItem("digital-form-dept-practice")}`,
                }),
            });

            if (!response.ok) {
                throw new Error(`Failed to get presigned URL: ${response.status} ${response.statusText}`);
            }

            const { url, key } = await response.json();

            if (!url) {
                throw new Error('No upload URL received from server');
            }


            // Try multiple upload methods for better iOS compatibility
            let uploadResponse;

            try {
                // Method 1: Try standard fetch first
                uploadResponse = await fetch(url, {
                    method: "PUT",
                    body: pdfBlob,
                    headers: {
                        "Content-Type": "application/pdf"
                    }
                });

                if (!uploadResponse.ok) {
                    throw new Error(`Fetch upload failed: ${uploadResponse.status}`);
                }

            } catch (fetchError) {
                console.log('Standard fetch failed, trying XHR...', fetchError.message);

                try {
                    // Method 2: Try XMLHttpRequest for iOS compatibility
                    uploadResponse = await handleUpload(url, pdfBlob);
                } catch (xhrError) {
                    console.error('XHR upload also failed:', xhrError.message);
                    throw new Error(`All upload methods failed. Last error: ${xhrError.message}`);
                }
            }

            return key;

        } catch (error) {
            console.error('Upload process failed:', error);
            throw new Error(`Upload process failed: ${error.message}`);
        }
    };

    // Main surgical form submission function
    const handleSurgerySubmit = async (e) => {
        e.preventDefault();
        setSurgeryUpload(true);

        if (!validateForm(currentPage)) {
            return; // Prevent navigation if validation fails
        }

        try {

            // Add small delay for UI feedback
            await new Promise(resolve => setTimeout(resolve, 500));
            const originalZoom = zoom;
            // Reset zoom to 100% before capture
            setZoom(1);
            // Capture the last page
            const capturedPage = await handleLastPage();
            setZoom(originalZoom);

            // Validate we have the required data
            if (!capturedPages || capturedPages.length === 0) {
                throw new Error('No captured pages available');
            }

            if (!template) {
                throw new Error('No template specified');
            }

            // Process all images
            const processedImages = await processImagesForSurgery(capturedPages, capturedPage, template);

            if (processedImages.length === 0) {
                throw new Error('No images were successfully processed');
            }

            // Generate PDF
            const { pdfBlob } = await generateSurgicalPDF(processedImages, localpatientid, apptId);

            // Upload PDF
            const uploadKey = await uploadSurgicalPDF(pdfBlob, localpatientid, apptId, config);

            // Update database
            await update_database(uploadKey);

            // Success feedback
            setSurgeryUpload(false);

            await showSuccess("Upload Completed", "Surgical form has been uploaded successfully!").then((result) => {
                if (result.isConfirmed) {
                    navigate('/daily-appointments');
                }
            });

        } catch (error) {
            console.error('Surgical form submission error:', error);

            await showCustomAlert("error", "Upload Failed", `Error: ${error.message}`, "Retry", () => {
                setTimeout(() => handleSurgerySubmit(e), 1000);
            });
        } finally {
            setSurgeryUpload(false);
        }
    };

    useEffect(() => {
        setCapturedPages(Array(totalPages).fill(null));
    }, [totalPages]);


    useEffect(() => {
        if (openedViaButton && !taskRunRef.current) {
            localStorage.setItem("digital-form-locked", true);
            checkTokenAndNavigate(runTask, tryRefresh, navigate);
        }
    }, [openedViaButton]);

    const pageTitles = {
        "Andrews Institute": {
            0: "Surgery Request Order Form",
            1: "ANDREWS INSTITUTE ASC",
            2: "ANDREWS INSTITUTE ASC, LLC RECORD OF INFORMED CONSENT",
            3: "ANDREWS INSTITUTE ASC, LLC RECORD OF INFORMED CONSENT",
            4: "ANDREWS INSTITUTE ASC, LLC RECORD OF INFORMED CONSENT",
            5: "RETINAL SURGERY PREOPERATIVE ORDERS",
            6: "REQUEST TO YOUR PHYSICIAN(S) FOR A PREOPERATIVE EVALUATION",
            7: "ANDREWS INSTITUTE PRE-ANESTHESIA PATIENT QUESTIONNAIRE",
            8: "ANDREWS INSTITUTE PRE-ANESTHESIA PATIENT QUESTIONNAIRE"
        },
        'Emerald Coast Surgery Center': {
            0: "EMERALD COAST SURGERY CENTER SCHEDULE/ADMISSION CENTER",
            1: "EMERALD COAST SURGERY CENTER SCHEDULE/ADMISSION CENTER",
            2: "CONSENT FOR MEDICAL AND SURGICAL PROCEDURES",
            3: "CONSENT FOR MEDICAL AND SURGICAL PROCEDURES",
            4: "EMERALD COAST SURGERY CENTER SCHEDULE/ADMISSION CENTER",
        },
        'Summit Surgery Center': {
            0: "CONSENT FOR MEDICAL AND SURGICAL PROCEDURES",
            1: "CONSENT FOR MEDICAL AND SURGICAL PROCEDURES"
        },
        'Baldwin Co Surgery Center': {
            0: "CONSENT FOR MEDICAL AND SURGICAL PROCEDURES",
            1: "CONSENT FOR MEDICAL AND SURGICAL PROCEDURES"
        },

    };

    useEffect(() => {
        if (template === "Andrews Institute") {
            setPageTitle(pageTitles['Andrews Institute'][currentPage]);
        }
        else if (template === "Emerald Coast Surgery Center") {
            setPageTitle(pageTitles["Emerald Coast Surgery Center"][currentPage]);
        }
        else if (template === "Summit Surgery Center") {
            setPageTitle(pageTitles["Summit Surgery Center"][currentPage]);
        }
        else if (template === "Baldwin Co Surgery Center") {
            setPageTitle(pageTitles["Baldwin Co Surgery Center"][currentPage]);
        }
    }, [currentPage, setPageTitle]); // Runs when currentPage changes

    const handleInputChange = (e) => {
        const { id, value } = e.target;

        setSurgeryFormData((prev) => {
            // Check if the input belongs to 'unable_to_sign' (nested state)
            if (id in prev.unable_to_sign) {
                return {
                    ...prev,
                    unable_to_sign: {
                        ...prev.unable_to_sign,
                        [id]: value, // Update nested field dynamically
                    },
                };
            }

            // Otherwise, update the top-level field
            return {
                ...prev,
                [id]: value,
            };
        });


    };

    const handleNestedInputChange = (e) => {
        const { id, value } = e.target;

        setSurgeryFormData((prev) => ({
            ...prev,
            unable_to_sign: {
                ...prev.unable_to_sign,
                [id]: value,
            },
        }));
    };


    const validatePage1 = () => {
        let FIELD_RULES = {};

        if (template === "Andrews Institute") {
            const PATTERNS = {
                ssn: /^\d{3}-\d{2}-\d{4}$|^\d{9}$/,
                phone: (value, country = "US") => {
                    const parsed = parsePhoneNumberFromString(value, country);
                    return parsed?.isValid() || false;
                },
            };

            FIELD_RULES = {
                first_name: { required: true, label: "First Name" },
                last_name: { required: true, label: "Last Name" },
                // gender: { required: true, label: "Gender" },
                // dob: { required: true, label: "Date of Birth" },
                // cellphone: {
                //     required: false,
                //     label: "Cell Phone",
                //     validate: (v) => !v || PATTERNS.phone(v),
                // },
                // office_phone: {
                //     required: false,
                //     label: "Office Phone",
                //     validate: (v) => !v || PATTERNS.phone(v),
                // },
                surgeon: { required: true, label: "Surgeon" },
                procedure_description: { required: true, label: "Procedure" },
                diagnosis: { required: true, label: "Diagnosis" },
                // anesthesia: { required: true, label: "Anesthesia" },
                // ssn: {
                //     required: false,
                //     label: "SSN",
                //     validate: (v) => !v || PATTERNS.ssn.test(v),
                // },
            };
        }

        else if (template === "Emerald Coast Surgery Center") {
            FIELD_RULES = {
                first_name: { required: true, label: "First Name" },
                last_name: { required: true, label: "Last Name" },
                dob: { required: true, label: "Date of Birth" },
                surgeon: { required: true, label: "Surgeon" },
                procedure_description: { required: true, label: "Procedure" },
                anesthesia: { required: true, label: "Anesthesia" },
            };
        }
        // ---------- VALIDATION ----------
        setInvalidFields([]);
        setCurrentPage(0);

        const invalidFieldsList = [];

        Object.entries(FIELD_RULES).forEach(([fieldName, rules]) => {
            const value = SurgeryFormData[fieldName];

            if (rules.required && !value) {
                invalidFieldsList.push(fieldName);
                return;
            }

            if (rules.validate && !rules.validate(value)) {
                invalidFieldsList.push(fieldName);
            }
        });

        if (invalidFieldsList.length > 0) {
            setInvalidFields(invalidFieldsList);

            const invalidFieldLabels = invalidFieldsList.map(
                (field) => FIELD_RULES[field].label
            );

            showCustomAlert("warning", "Missing or Invalid Fields", `Please fill out:\n- ${invalidFieldLabels.join("\n- ")}`);

            return false;
        }

        return true;
    };

    const validatePage2 = () => {
        let FIELD_RULES = {};

        if (template === "Summit Surgery Center") {

            FIELD_RULES = {
                procedure: { required: true, label: "Procedure" },
                diagnosis: { required: true, label: "Diagnosis" },
                anesthesia: { required: true, label: "Anesthesia" }
            };
        }

        // ---------- VALIDATION ----------
        setInvalidFields([]);

        const invalidFieldsList = [];

        Object.entries(FIELD_RULES).forEach(([fieldName, rules]) => {
            const value = SurgeryFormData[fieldName];

            if (rules.required && !value) {
                invalidFieldsList.push(fieldName);
                return;
            }

            if (rules.validate && !rules.validate(value)) {
                invalidFieldsList.push(fieldName);
            }
        });

        if (invalidFieldsList.length > 0) {
            setInvalidFields(invalidFieldsList);

            const invalidFieldLabels = invalidFieldsList.map(
                (field) => FIELD_RULES[field].label
            );

            showCustomAlert("warning", "Missing or Invalid Fields", `Please fill out:\n- ${invalidFieldLabels.join("\n- ")}`);

            return false;
        }

        return true;
    };

    const validateForm = (page) => {
        switch (page) {
            case 0:
                return validatePage1();
            case 1:
                if (template === 'Summit Surgery Center') {
                    return validatePage2()
                }
                return true
            default:
                return true
        }
    };

    const handleCheckboxChange = (category, item, value) => {
        setSurgeryFormData(prevState => ({
            ...prevState,
            [category]: {
                ...prevState[category],
                [item]: value
            }
        }));
    };

    const toggleEditMode = (type, editMode) => {
        clearSignature(type)
        setIsEditing((prev) => ({
            ...prev,
            [type]: editMode,
        }));
    };


    const updateSignatureData = (type) => {
        const canvas = canvasRefs[type].current;
        if (canvas) {
            const dataUrl = canvas.toDataURL(0.3);
            setSignatures((prev) => ({
                ...prev,
                [type]: dataUrl,
            }));
            setSurgeryFormData((prev) => ({
                ...prev,
                [type]: dataUrl, // Temporarily store in original format
            }));
            if (type === 'patient_signature') {
                setSurgeryFormData((prev) => ({
                    ...prev,
                    patientSignedDate: getCentralAmericaDate(),
                    patientSignedTime: getCentralAmericaTime(),
                }));
            }
            if (type === 'witness_signature') {
                setSurgeryFormData((prev) => ({
                    ...prev,
                    witnessSignedDate: getCentralAmericaDate(),
                    witnessSignedTime: getCentralAmericaTime(),
                }));
            }
            if (type === 'rn_signature') {
                setSurgeryFormData((prev) => ({
                    ...prev,
                    rnSignedDate: getCentralAmericaDate(),
                    rnSignedTime: getCentralAmericaTime(),
                }));
            }
            if (type === 'surrogate_signature') {
                setSurgeryFormData((prev) => ({
                    ...prev,
                    surrogateSignedDate: getCentralAmericaDate(),
                    surrogateSignedTime: getCentralAmericaTime(),
                }));
            }
            if (type === 'noted_signature') {
                setSurgeryFormData((prev) => ({
                    ...prev,
                    noted_date: getCentralAmericaDate(),
                    noted_time: getCentralAmericaTime(),
                }));
            }


        }
    };

    const clearSignature = (type) => {
        const canvas = canvasRefs[type]?.current;

        if (canvas) {
            // Clear the canvas if it exists
            canvas.clear();
        }

        // Clear the signature data from states
        setSignatures((prev) => ({
            ...prev,
            [type]: '',
        }));

        setSurgeryFormData((prev) => ({
            ...prev,
            [type]: '', // Remove signature from form data
        }));

        // Optionally, exit edit mode if in edit mode
        setIsEditing((prev) => ({
            ...prev,
            [type]: false,
        }));
    };

    const handleNext = async () => {

        if (!validateForm(currentPage)) {
            return; // Prevent navigation if validation fails
        }
        else {
            setNextLoader(true);
            setIsNext(true)
            // Save current zoom
            const originalZoom = zoom;
            // Reset zoom to 100% before capture
            setZoom(1);
            await capturePageAsImage()
            setZoom(originalZoom);
            setIsNext(false)
            setNextLoader(false);
            setCurrentPage(currentPage + 1);
        }

    };

    const handleBackClick = () => {
        setCurrentPage(currentPage - 1);
    };




    return (
        <div className="min-h-screen flex justify-center bg-gray-50">
            <div className="min-h-screen flex flex-col bg-white">
                {isLoading3 && (
                    <Refresh />
                )}
                {isLoading4 && (
                    <Writing />
                )}
                {nextLoader && (
                    <NextBtnLoader />
                )}
                {surgeryUpload && (
                    <Rocket />
                )}
                <Header pageTitle={template !== '' ? pageTitles[template][currentPage] : 'Surgical Forms'} />

                {currentPage > 0 && (
                    <Back onClick={handleBackClick} />
                )}
                {
                    template === 'Andrews Institute' && (
                        <Andrews
                            SurgeryFormData={SurgeryFormData}
                            setSurgeryFormData={setSurgeryFormData}
                            currentPage={currentPage}
                            pageRefs={pageRefs}
                            pageTitles={pageTitles}
                            isNext={isNext}
                            invalidFields={invalidFields}
                            handleInputChange={handleInputChange}
                            handleCheckboxChange={handleCheckboxChange}
                            verifyDob={verifyDob}
                            setVerifyDob={setVerifyDob}
                            signatures={signatures}
                            setSignatures={setSignatures}
                            isEditing={isEditing}
                            toggleEditMode={toggleEditMode}
                            updateSignatureData={updateSignatureData}
                            clearSignature={clearSignature}
                            canvasRefs={canvasRefs}
                            surgeonFullnameOptionsMap={surgeonFullnameOptionsMap}
                            surgeonOptionsMap={surgeonOptionsMap}
                            docSignature={docSignature}
                            logo={logo}
                            renderNextButton={renderNextButton}
                            renderSurgeryUploadButton={renderSurgeryUploadButton}
                            surgeryUpload={surgeryUpload}
                            formatDate={formatDate}
                            handleMedicationTimeChange={handleMedicationTimeChange}
                            getCentralAmericaDate={getCentralAmericaDate}
                            getCentralAmericaTime={getCentralAmericaTime}
                            handleNext={handleNext}
                            Head={Head}
                            SignatureField={SignatureField}
                            Paragraph={Paragraph}
                            FormInput={FormInput}
                            Logo={Logo}
                            DOBPickerInput={DOBPickerInput}
                            SelectInput={SelectInput}
                            TimePickerInput={TimePickerInput}
                            TextInput={TextInput}
                            SurgeryInfoDisplay={SurgeryInfoDisplay}
                            DatePickerInput={DatePickerInput}
                            RadioGroup={RadioGroup}
                            anesthesiaOptions={anesthesiaOptions}
                            eyesOptions={eyesOptions}
                            TextAreaInput={TextAreaInput}
                            MedTimePicker={MedTimePicker}
                            andrews={andrews}
                            handleNestedInputChange={handleNestedInputChange}
                            displayDate={displayDate}
                            TextArea={TextArea}
                        />
                    )
                }

                {
                    template === 'Emerald Coast Surgery Center' && (
                        <Emerald
                            SurgeryFormData={SurgeryFormData}
                            setSurgeryFormData={setSurgeryFormData}
                            currentPage={currentPage}
                            pageRefs={pageRefs}
                            pageTitles={pageTitles}
                            isNext={isNext}
                            invalidFields={invalidFields}
                            handleInputChange={handleInputChange}
                            handleCheckboxChange={handleCheckboxChange}
                            verifyDob={verifyDob}
                            setVerifyDob={setVerifyDob}
                            signatures={signatures}
                            setSignatures={setSignatures}
                            isEditing={isEditing}
                            toggleEditMode={toggleEditMode}
                            updateSignatureData={updateSignatureData}
                            clearSignature={clearSignature}
                            canvasRefs={canvasRefs}
                            surgeonOptionsMap={surgeonOptionsMap}
                            docSignature={docSignature}
                            logo={logo}
                            renderNextButton={renderNextButton}
                            renderSurgeryUploadButton={renderSurgeryUploadButton}
                            surgeryUpload={surgeryUpload}
                            formatDate={formatDate}
                            handleMedicationTimeChange={handleMedicationTimeChange}
                            getCentralAmericaDate={getCentralAmericaDate}
                            getCentralAmericaTime={getCentralAmericaTime}
                            handleNext={handleNext}
                            Head={Head}
                            SignatureField={SignatureField}
                            Paragraph={Paragraph}
                            FormInput={FormInput}
                            Logo={Logo}
                            DOBPickerInput={DOBPickerInput}
                            SelectInput={SelectInput}
                            TimePickerInput={TimePickerInput}
                            TextInput={TextInput}
                            SurgeryInfoDisplay={SurgeryInfoDisplay}
                            DatePickerInput={DatePickerInput}
                            RadioGroup={RadioGroup}
                            anesthesiaOptions={anesthesiaOptions}
                            TextAreaInput={TextAreaInput}
                            MedTimePicker={MedTimePicker}
                        />
                    )
                }

                {
                    template === 'Summit Surgery Center' &&
                    (
                        <OneMedical
                            SurgeryFormData={SurgeryFormData}
                            setSurgeryFormData={setSurgeryFormData}
                            currentPage={currentPage}
                            pageRefs={pageRefs}
                            pageTitles={pageTitles}
                            isNext={isNext}
                            invalidFields={invalidFields}
                            handleInputChange={handleInputChange}
                            handleCheckboxChange={handleCheckboxChange}
                            verifyDob={verifyDob}
                            setVerifyDob={setVerifyDob}
                            signatures={signatures}
                            setSignatures={setSignatures}
                            isEditing={isEditing}
                            toggleEditMode={toggleEditMode}
                            updateSignatureData={updateSignatureData}
                            clearSignature={clearSignature}
                            canvasRefs={canvasRefs}
                            surgeonOptionsMap={surgeonOptionsMap}
                            docSignature={docSignature}
                            logo={logo}
                            renderNextButton={renderNextButton}
                            renderSurgeryUploadButton={renderSurgeryUploadButton}
                            surgeryUpload={surgeryUpload}
                            formatDate={formatDate}
                            handleMedicationTimeChange={handleMedicationTimeChange}
                            getCentralAmericaDate={getCentralAmericaDate}
                            getCentralAmericaTime={getCentralAmericaTime}
                            handleNext={handleNext}
                            Paragraph={Paragraph}
                            Logo={Logo}
                            Head={Head}
                            SignatureField={SignatureField}
                            TextInput={TextInput}
                            MedTimePicker={MedTimePicker}
                            TextArea={TextArea}
                            DatePickerInput={DatePickerInput}
                            RadioGroup={RadioGroup}
                            RSIConsent={RSIConsent}
                        />
                    )
                }

                {
                    template === 'Baldwin Co Surgery Center' &&
                    (
                        <Baldwin
                            SurgeryFormData={SurgeryFormData}
                            setSurgeryFormData={setSurgeryFormData}
                            currentPage={currentPage}
                            pageRefs={pageRefs}
                            pageTitles={pageTitles}
                            isNext={isNext}
                            invalidFields={invalidFields}
                            handleInputChange={handleInputChange}
                            handleCheckboxChange={handleCheckboxChange}
                            verifyDob={verifyDob}
                            setVerifyDob={setVerifyDob}
                            signatures={signatures}
                            setSignatures={setSignatures}
                            isEditing={isEditing}
                            toggleEditMode={toggleEditMode}
                            updateSignatureData={updateSignatureData}
                            clearSignature={clearSignature}
                            canvasRefs={canvasRefs}
                            surgeonOptionsMap={surgeonOptionsMap}
                            docSignature={docSignature}
                            logo={logo}
                            renderNextButton={renderNextButton}
                            renderSurgeryUploadButton={renderSurgeryUploadButton}
                            surgeryUpload={surgeryUpload}
                            formatDate={formatDate}
                            handleMedicationTimeChange={handleMedicationTimeChange}
                            getCentralAmericaDate={getCentralAmericaDate}
                            getCentralAmericaTime={getCentralAmericaTime}
                            handleNext={handleNext}
                            Paragraph={Paragraph}
                            Logo={Logo}
                            Head={Head}
                            SignatureField={SignatureField}
                            TextInput={TextInput}
                            MedTimePicker={MedTimePicker}
                            TextArea={TextArea}
                            DatePickerInput={DatePickerInput}
                            RadioGroup={RadioGroup}
                            RSIConsent={RSIConsent}
                            formattedDate={formattedDate}
                            LeftCheckBox={LeftCheckBox}
                            handleProcedureChange={handleProcedureChange}
                        />
                    )
                }

            </div>
        </div>
    );
};

export default SurgeryPageForm;